<script>
  import { slide } from 'svelte/transition'
  import Fa from "svelte-fa"
  import {
    faUtensils,
    faFireBurner,
    faHourglassEnd,
    faPeopleGroup,
    faFire,
    faChevronDown
  } from "@fortawesome/free-solid-svg-icons"

  export let cooking_info

  const fields = [
    { key: 'prep_time', icon: faUtensils, label: 'Prep', type: 'text', placeholder: 'time' },
    { key: 'cook_time', icon: faFireBurner, label: 'Cook', type: 'text', placeholder: 'time' },
    { key: 'total_time', icon: faHourglassEnd, label: 'Total', type: 'text', placeholder: 'time' },
    { key: 'yield', icon: faPeopleGroup, label: 'Servings', type: 'number', placeholder: '—' },
    { key: 'calories', icon: faFire, label: 'Cal/serv', type: 'number', placeholder: '—' }
  ]

  function onInputClick(e) {
    e.target.select()
  }

  // Nutrition
  let showNutrition = false

  const nutritionFields = [
    { key: 'protein', bgClass: 'bg-accent', textClass: 'text-accent' },
    { key: 'carbs', bgClass: 'bg-honey', textClass: 'text-honey' },
    { key: 'fat', bgClass: 'bg-primary', textClass: 'text-primary' },
    { key: 'fiber', bgClass: 'bg-sapphire', textClass: 'text-sapphire' },
    { key: 'sugars', bgClass: 'bg-plum', textClass: 'text-plum' },
    { key: 'sodium', bgClass: 'bg-danger', textClass: 'text-danger', unit: 'mg' }
  ]

  const toggleNutrition = () => showNutrition = !showNutrition
</script>

<div>
  <div class="flex flex-wrap items-center gap-x-4 gap-y-4 md:gap-y-2 text-sm border-b border-t border-border py-2 md:py-2">
    {#each fields as field}
      <div class="flex items-center gap-1.5">
        <Fa icon={field.icon} class="text-xs text-fg-muted" />
        <span class="text-fg-muted">{field.label}</span>
        {#if field.type === 'number'}
          <input
            type="number"
            bind:value={cooking_info[field.key]}
            on:focus={onInputClick}
            placeholder={field.placeholder}
            class="cooking-input"
          />
        {:else}
          <input
            type="text"
            bind:value={cooking_info[field.key]}
            on:focus={onInputClick}
            placeholder={field.placeholder}
            class="cooking-input"
          />
        {/if}
      </div>
    {/each}

    <button class="flex gap-2 items-center text-accent hover:text-accent-hover" on:click={toggleNutrition}>
      <span>Nutrition</span>
      <span class="transition-transform duration-200" class:rotate-180={showNutrition}>
        <Fa icon={faChevronDown} class="text-xs" />
      </span>
    </button>
  </div>

  {#if showNutrition}
    <div transition:slide={{ duration: 200 }} class="w-full px-4 py-3 bg-surface border border-border rounded-lg mt-2">
      <div class="flex justify-between text-xs uppercase border-b border-border text-clay-dark pb-2">
        <div>Macro</div>
        <div>/ Serving</div>
      </div>

      {#each nutritionFields as field}
        <div class="flex justify-between border-b border-dashed border-border py-2 text-sm">
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 rounded-sm {field.bgClass}"/>
            <span class="capitalize">
              {field.key}
            </span>
          </div>
          <div class="flex items-center gap-1">
            <input
              type="number"
              min="0"
              bind:value={cooking_info[field.key]}
              on:focus={onInputClick}
              class="cooking-input cooking-input-macro {field.textClass}"
            />
            <div class="w-2 text-xs text-slate">{field.unit ?? 'g'}</div>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .cooking-input {
    @apply border text-sm border-transparent bg-transparent appearance-none rounded w-10 py-0 px-1 cursor-pointer;
    @apply focus:bg-white focus:shadow focus:border focus:outline-none;
  }

  .cooking-input-macro {
    @apply px-0 text-right font-semibold text-sm;
  }

  .cooking-input::placeholder {
    @apply text-fg-muted/40;
  }

  /* Hide number input spinners */
  .cooking-input[type="number"]::-webkit-outer-spin-button,
  .cooking-input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .cooking-input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
